import React from 'react';
import generalSettingFunctional from './index.function';
import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import { Dropdown } from '../../components';
import ViewReverse from '../../components/ViewReverse';
import Button from '../../components/Button';
import Divider from '../../components/Divider';
import icons from '../../constants/icons';
import { ReactSVG } from 'react-svg';
import { Formik } from 'formik';
import { change_password_schema, change_password_validation_schema } from '../../validations_schemas/change_password_validation';
import CustomInput from '../../components/CustomInput';
import { rowReverseStylemd } from '../../utils/styles';
import ErrorText from '../../components/ErrorText';
import ViewItems from '../../components/ViewItems';
import { cn } from '../../utils/utils';
import LoaderModal from '../../components/LoaderModal';
import SarSymbol from '../../components/SarSymbol';
import AccountCard from '../../components/AccountCard';
import ConfirmModal from '../../components/ConfirmModal';

const GeneralSettings = () => {
  const {
    isArabic,
    navigate,
    TextWeight,
    settingLoading,
    languageLoading,
    languages,
    passwordLoading,
    selectedLanguage,
    getContentKey,
    onLanguageSelect,
    handleSubmitLanguage,
    handleSubmitPassword,
    clientDetails,
    handleKycUpdate,
    kyc_loading,
    clientId,
    vatNumber,
    user,
    confirmModal,
    setConfirmModal,
    handleOpenModel,
    handleCloseModel,
    handleSwitchAccount,
    direction,
    authLoading,
  } = generalSettingFunctional();

  return (
    <ViewItems>
      <Text text={getContentKey('heading')} weight={TextWeight.bold} size={fontSizes.h18} />

      <ViewReverse className={cn('flex w-full gap-4 flex-col sm:flex-row', rowReverseStylemd(isArabic))}>
        <ViewItems className={'flex flex-col justify-items-start border mt-3 sm:mt-6 border-grey px-5 pt-6 pb-4 shadow-light rounded-xl w-full sm:w-1/2'}>
          <Text text={getContentKey('client_information')} size={fontSizes.h16} weight={TextWeight.semiBold} />

          <ViewReverse className={'w-full mt-2 border-b border-b-grey py-3 justify-between'}>
            <Text text={getContentKey('client_id')} size={fontSizes.h14} />
            <Text text={clientId} size={fontSizes.h14} weight={TextWeight.semiBold} color='text-primary' />
          </ViewReverse>
          <ViewReverse className={'w-full border-b border-b-grey py-3 justify-between'}>
            <Text text={getContentKey('client_since')} size={fontSizes.h14} />
            <Text dir={"ltr"} text={clientDetails?.clientInformation?.clientSince} size={fontSizes.h14} weight={TextWeight.semiBold} color='text-primary' />
          </ViewReverse>
          {/* <ViewReverse className={'w-full py-3 border-b border-b-grey justify-between'}>
            <Text text={getContentKey('reporting_as_of')} size={fontSizes.h14} />
            <Text dir={"ltr"} text={clientDetails?.clientInformation?.reportingAsOf} size={fontSizes.h14} weight={TextWeight.semiBold} color='text-primary' />
          </ViewReverse> */}
          <ViewReverse className={'w-full pt-3 justify-between'}>
            <Text text={getContentKey('reporting_currency')} size={fontSizes.h14} />
            {clientDetails?.clientInformation?.reportingCurrency === 'SAR' ? (
              <SarSymbol className={'text-primary'} />
            ) : (
              <Text
                text={clientDetails?.clientInformation?.reportingCurrency}
                size={fontSizes.h14}
                weight={TextWeight.semiBold}
                color='text-primary'
              />
            )}
          </ViewReverse>
        </ViewItems>
        <ViewItems className={'flex flex-col justify-items-start border sm:mt-6 border-grey px-5 pt-6 pb-4 shadow-light rounded-xl w-full sm:w-1/2'}>
          <Text text={getContentKey('general_heading')} size={fontSizes.h16} weight={TextWeight.semiBold} />
          <ViewReverse className={'w-full mt-2 border-b border-b-grey py-3 justify-between'}>
            <Text text={getContentKey('help')} size={fontSizes.h14} />
            <ViewReverse className={'gap-2 items-center cursor-pointer'} onClick={() => navigate('/help/ticketing-history')}>
              <Text text={getContentKey('click_here')} size={fontSizes.h14} color={'text-primary'} />
              <ReactSVG src={icons.openLink} className='mb-1' />
            </ViewReverse>
          </ViewReverse>

          <ViewReverse className={'w-full py-3 justify-between border-b border-b-grey'}>
            <Text text={getContentKey('kyc_heading')} size={fontSizes.h14} />
            <ViewReverse onClick={() => handleKycUpdate(false)} className={'gap-2 items-center cursor-pointer'}>
              <Text text={getContentKey('click_here')} size={fontSizes.h14} color={'text-primary'} />
              <ReactSVG src={icons.openLink} className='mb-1' />
            </ViewReverse>
          </ViewReverse>

          <ViewReverse className={'flex flex-row w-full py-3 justify-between border-b gap-5 border-b-grey'}>
            <Text
              text={getContentKey('client_clasification_heading')}
              size={fontSizes.h14}
              isTruncate={false}
            />
            <ViewReverse onClick={() => handleKycUpdate(true)} className={'gap-2 items-center cursor-pointer'}>
              <Text text={getContentKey('click_here')} size={fontSizes.h14} color={'text-primary'} />
              <ReactSVG src={icons.openLink} className='mb-1' />
            </ViewReverse>
          </ViewReverse>

          <ViewReverse className={'w-full py-3 justify-between border-b border-b-grey'}>
            <Text text={getContentKey('faqs')} size={fontSizes.h14} />
            <ViewReverse onClick={() => navigate('/help/faqs')} className={'gap-2 items-center cursor-pointer'}>
              <Text text={getContentKey('click_here')} size={fontSizes.h14} color={'text-primary'} />
              <ReactSVG src={icons.openLink} className='mb-1' />
            </ViewReverse>
          </ViewReverse>

          {
            process.env.REACT_APP_ENVIRONMENT !== 'PRODUCTION' && (
              <ViewReverse className={'w-full py-3 justify-between border-b border-b-grey'}>
                <Text text={getContentKey('account_closure')} size={fontSizes.h14} />
                <ViewReverse onClick={() => navigate('/help/account-closure')} className={'gap-2 items-center cursor-pointer'}>
                  <Text text={getContentKey('click_here')} size={fontSizes.h14} color={'text-primary'} />
                  <ReactSVG src={icons.openLink} className='mb-1' />
                </ViewReverse>
              </ViewReverse>
            )
          }

          <ViewReverse className={'w-full pt-3 justify-between'}>
            <Text text={getContentKey('vat_number')} size={fontSizes.h14} />
            <ViewReverse onClick={() => navigate('/settings/general-settings/edit-vat-number')} className={'gap-2 items-center cursor-pointer'}>
              <Text text={vatNumber ?? '————'} size={fontSizes.h14} color={'text-primary'} />
              <ReactSVG src={icons.editIcon} className='mb-1' />
            </ViewReverse>
          </ViewReverse>
        </ViewItems>
      </ViewReverse>

      <ViewItems className={'border mt-6 border-grey px-5 p-6 shadow-light rounded-xl w-full'}>
        <Text text={getContentKey('language')} size={fontSizes.h18} weight={TextWeight.bold} />
        <ViewReverse className='mt-4 w-full items-center gap-4'>
          <Dropdown
            width='w-full md:w-1/2'
            label={getContentKey('lang_label')}
            options={languages}
            valueKey={'name'}
            selectedValue={selectedLanguage}
            onSelect={onLanguageSelect}
          />
          <div className='w-1/2 hidden sm:block' />
        </ViewReverse>
        <Divider margin='my-0 mt-4' />

        <ViewReverse className='items-center w-full gap-2 mt-4'>
          <Button
            text={getContentKey('save_btn')}
            onClick={handleSubmitLanguage}
            bgColor='bg-primary'
            className={'uppercase w-36 px-0 text-center border border-orange'}
            loading={languageLoading}
          />
          <Button
            text={getContentKey('cancel_btn')}
            color={'text-primary'}
            bgColor='bg-white'
            className={'uppercase border border-primary w-36 px-0 text-center'}
          />
        </ViewReverse>
      </ViewItems>

      <Formik
        validationSchema={change_password_validation_schema}
        initialValues={change_password_schema}
        onSubmit={(values) => handleSubmitPassword(values)}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ handleSubmit, setFieldValue, values, errors }) => (
          <ViewItems className={'border mt-6 border-grey px-5 p-6 shadow-light rounded-xl w-full'}>
            <Text text={getContentKey('change_pass')} size={fontSizes.h18} weight={TextWeight.bold} />

            <ViewReverse className={cn('flex w-full gap-2 mt-4 md:gap-8 flex-col', rowReverseStylemd(isArabic))}>
              <ViewItems className={'w-full'}>
                <CustomInput
                  label={getContentKey('old_pass_label')}
                  placeholder={getContentKey('old_pass_placeholder')}
                  type={'password'}
                  isRounded
                  isRequired
                  value={values?.old_password}
                  onChange={(val) => setFieldValue('old_password', val.target.value)}
                  isError={errors?.old_password}
                />
                <ErrorText text={getContentKey(errors?.old_password)} />
              </ViewItems>
              <ViewItems className={'w-full'}>
                <CustomInput
                  label={getContentKey('new_pass_label')}
                  placeholder={getContentKey('new_pass_placeholder')}
                  type={'password'}
                  isRounded
                  isRequired
                  value={values?.new_password}
                  onChange={(val) => setFieldValue('new_password', val.target.value)}
                  isError={errors?.new_password}
                />
                <ErrorText text={getContentKey(errors?.new_password)} />
              </ViewItems>
            </ViewReverse>
            <ViewReverse className={cn('flex w-full gap-2 md:gap-8 flex-col', rowReverseStylemd(isArabic))}>
              <ViewItems className={'w-full'}>
                <CustomInput
                  label={getContentKey('confirm_pass_label')}
                  placeholder={getContentKey('new_pass_placeholder')}
                  type={'password'}
                  isRounded
                  isRequired
                  divClasses={'mt-4'}
                  value={values?.confirm_password}
                  onChange={(val) => setFieldValue('confirm_password', val.target.value)}
                  isError={errors?.confirm_password}
                />
                <ErrorText text={getContentKey(errors?.confirm_password)} />
              </ViewItems>
              <div className={'w-full'} />
            </ViewReverse>
            <ViewReverse className={cn('flex w-full gap-2 md:gap-8 flex-col mt-6', rowReverseStylemd(isArabic))}>
              <ViewItems className={'w-full border rounded-xl border-golden-yellow p-4 md:p-5 bg-transparent-amber'}>
                <ReactSVG src={icons.passwordValidation} className='w-8 mb-4' />
                <Text text={getContentKey('pass_validation_heading')} color={'text-golden-yellow'} size={fontSizes.h14} weight={TextWeight.bold} />
                {/* <ul className={''}>
                  <li>
                    <Text
                      text={getContentKey('pass_validation_1')}
                      color={'text-golden-yellow'}
                      size={fontSizes.h14}
                      isTruncate={false}
                      weight={TextWeight.regular}
                    />
                  </li>
                  <li>
                    <Text
                      text={getContentKey('pass_validation_2')}
                      color={'text-golden-yellow'}
                      size={fontSizes.h14}
                      isTruncate={false}
                      weight={TextWeight.regular}
                    />
                  </li>
                  <li>
                    <Text
                      text={getContentKey('pass_validation_3')}
                      color={'text-golden-yellow'}
                      size={fontSizes.h14}
                      isTruncate={false}
                      weight={TextWeight.regular}
                    />
                  </li>
                  <li>
                    <Text
                      text={getContentKey('pass_validation_4')}
                      size={fontSizes.h14}
                      color={'text-golden-yellow'}
                      isTruncate={false}
                      weight={TextWeight.regular}
                    />
                  </li>
                </ul> */}
                <ul>
                  <li>
                    <Text
                      text={getContentKey('pass_validation_5')}
                      color={'text-golden-yellow'}
                      size={fontSizes.h14}
                      isTruncate={false}
                      weight={TextWeight.regular}
                    />
                  </li>
                  <li>
                    <Text
                      text={getContentKey('pass_validation_8')}
                      color={'text-golden-yellow'}
                      size={fontSizes.h14}
                      isTruncate={false}
                      weight={TextWeight.regular}
                    />
                  </li>
                  <li>
                    <Text
                      text={getContentKey('pass_validation_7')}
                      color={'text-golden-yellow'}
                      size={fontSizes.h14}
                      isTruncate={false}
                      weight={TextWeight.regular}
                    />
                  </li>
                  <li>
                    <Text
                      text={getContentKey('pass_validation_9')}
                      color={'text-golden-yellow'}
                      size={fontSizes.h14}
                      isTruncate={false}
                      weight={TextWeight.regular}
                    />
                  </li>
                  <li>
                    <Text
                      text={getContentKey('pass_validation_6')}
                      size={fontSizes.h14}
                      color={'text-golden-yellow'}
                      isTruncate={false}
                      weight={TextWeight.regular}
                    />
                  </li>
                </ul>
              </ViewItems>
              <div className={'w-full '} />
            </ViewReverse>

            <Divider />

            <ViewReverse className='items-center w-full gap-2'>
              <Button
                text={getContentKey('save_btn')}
                bgColor='bg-primary'
                className={'uppercase w-36 px-0 text-center border border-orange'}
                onClick={handleSubmit}
                loading={passwordLoading}
              />
              <Button
                text={getContentKey('cancel_btn')}
                color={'text-primary'}
                bgColor='bg-white'
                className={'uppercase border border-primary w-36 px-0 text-center'}
              />
            </ViewReverse>
          </ViewItems>
        )}
      </Formik>

      {
        user?.linkedAccounts?.length > 0 && (
          <ViewItems className={'border mt-6 border-grey px-5 p-6 shadow-light rounded-xl w-full'}>
            <Text text={getContentKey('switch_account_heading')} size={fontSizes.h18} weight={TextWeight.bold} />
            <div dir={direction} className='grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 mt-4'>
              <AccountCard
                data={user?.linkedAccounts}
                currentClientId={user?.clientId}
                isPending={true}
                isSelectedIcon={true}
                onPressApplication={handleOpenModel}
              />
            </div>
          </ViewItems>
        )
      }

      <ConfirmModal
        open={confirmModal}
        onClose={handleCloseModel}
        title={getContentKey('confirmation_heading')}
        description={getContentKey('switch_confirmation')}
        loading={authLoading}
        isVertical={true}
        showConfirmIcon={true}
        onConfirm={handleSwitchAccount}
      />

      <LoaderModal open={kyc_loading} />
    </ViewItems>
  );
};

export default GeneralSettings;
